var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10327 7.99998C7.10327 8.28585 7.20945 8.53088 7.43814 8.74324L13.7925 14.967C13.9722 15.1466 14.2009 15.2447 14.4705 15.2447C15.0095 15.2447 15.4424 14.8199 15.4424 14.2727C15.4424 14.0032 15.3281 13.7663 15.1484 13.5785L9.42287 7.99998L15.1484 2.4215C15.3281 2.23365 15.4424 1.98862 15.4424 1.72726C15.4424 1.18003 15.0095 0.75531 14.4705 0.75531C14.2009 0.75531 13.9722 0.853321 13.7925 1.03301L7.43814 7.24856C7.20945 7.46909 7.10327 7.71412 7.10327 7.99998Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89685 7.99996C8.89685 7.71409 8.79067 7.46906 8.56198 7.2567L2.20758 1.03298C2.02789 0.853293 1.7992 0.755281 1.52966 0.755281C0.990602 0.755281 0.557719 1.18 0.557719 1.72723C0.557718 1.99676 0.672065 2.23362 0.851752 2.42147L6.57725 7.99995L0.851751 13.5784C0.672064 13.7663 0.557717 14.0113 0.557717 14.2727C0.557717 14.8199 0.990601 15.2446 1.52966 15.2446C1.79919 15.2446 2.02789 15.1466 2.20758 14.9669L8.56198 8.75138C8.79067 8.53085 8.89685 8.28582 8.89685 7.99996Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic-close.90cce6388dc9fde696a4db884bf09c96.svg";
export { ForwardRef as ReactComponent };